let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5GJST")).then(() => parcelRequire('8vvws'));